module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form', {
    staticClass: "mb-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm($event)
      }
    }
  }, [_c('action-buttons', {
    ref: "actionButtons",
    staticClass: "pull-right",
    attrs: {
      "disable-next": true,
      "disable-previous": true,
      "disable-save-and-new": true,
      "disable-delete": _vm.mode == 'add',
      "isDeleting": _vm.isDeleting,
      "delete-name": "dit voorlopige bod"
    },
    on: {
      "save": _vm.submitForm,
      "save-and-back": _vm.submitFormAndBack,
      "back": _vm.goBack,
      "delete": _vm.deletePendingBid
    }
  }), _vm._v(" "), (_vm.mode == 'edit') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('pendingBid.editTitle')))]) : _vm._e(), _vm._v(" "), (_vm.mode == 'add') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('pendingBid.addTitle')))]) : _vm._e(), _vm._v(" "), (_vm.formError.errors) ? _c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": ""
    }
  }, _vm._l((_vm.formError.errors), function(errors) {
    return _c('span', _vm._l((errors), function(error) {
      return _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(error) + "\n\t\t\t\t\t\t"), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('b-jumbotron', {
    staticClass: "mb-3 p-4"
  }, [(_vm.item) ? _c('h3', [_vm._v(_vm._s(_vm.$t('pendingBid.pendingBidOnItem')) + "\n\t\t\t\t\t\t"), _c('router-link', {
    attrs: {
      "to": {
        name: 'item',
        params: {
          itemId: _vm.item.id
        }
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.item.seller.code) + "-" + _vm._s(_vm.item.number))]), _vm._v(" " + _vm._s(_vm.item.title) + ".\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.item) ? _c('h4', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(((_vm.$t('pendingBid.auctionOrderNumberSmall')) + " " + (_vm.item.auction_order_number))) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('p', [(_vm.mode == 'edit') ? _c('small', [_vm._v("Aangemaakt op " + _vm._s(_vm._f("bigDate")(_vm.bid.created_at)))]) : _vm._e()]), _vm._v(" "), (_vm.bid.pending_bid_number) ? _c('h2', {
    staticClass: "font-italic"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('bid.bidNumber')) + " " + _vm._s(_vm.bid.pending_bid_number) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('person-info', {
    attrs: {
      "person": _vm.bid.buyer
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('pendingBid.price')
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t€\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "step": "1",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.price),
      callback: function($$v) {
        _vm.$set(_vm.form, "price", $$v)
      },
      expression: "form.price"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-6"
  }, [_c('autocomplete-person', {
    attrs: {
      "selected": (this.form.buyer_id) ? this.form.buyer_id : _vm.bid.buyer,
      "label": _vm.$t('common.buyer')
    },
    on: {
      "update:person": _vm.buyerIsUpdated
    }
  })], 1)]), _vm._v(" "), (_vm.mode == 'add') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('pendingBid.bidNumbers')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.bidNumberTypeSelection.options
    },
    model: {
      value: (_vm.bidNumberTypeSelection.selection),
      callback: function($$v) {
        _vm.$set(_vm.bidNumberTypeSelection, "selection", $$v)
      },
      expression: "bidNumberTypeSelection.selection"
    }
  })], 1), _vm._v(" "), (_vm.bidNumberTypeSelection.selection == 'existing') ? _c('b-form-group', {
    attrs: {
      "label": _vm.$t('pendingBid.selectBidNumber')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.bidNumberSelection.options
    },
    model: {
      value: (_vm.bidNumberSelection.selection),
      callback: function($$v) {
        _vm.$set(_vm.bidNumberSelection, "selection", $$v)
      },
      expression: "bidNumberSelection.selection"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e()], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bb9c2c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/PendingBid/PendingBidForm.vue
// module id = 1325
// module chunks = 1